var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.blogListingHero)?_c(_vm.modules.BlogListingHero,_vm._b({tag:"component"},'component',_vm.blogListingHero,false)):_vm._e(),_vm._v(" "),_c(_vm.modules.BlogListing,_vm._b({tag:"component"},'component',_vm.blogListing,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }